module.exports = __webpack_public_path__ + "static/media/XIIe.4882daa9.jpg";